import { STORAGE_KEYS, storage, mockDelay, ensureSeedData } from "./storage";

ensureSeedData();

export const notificationService = {
  async list() {
    await mockDelay(120);
    return storage
      .get(STORAGE_KEYS.notifications, [])
      .slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  },

  async unreadCount() {
    const list = storage.get(STORAGE_KEYS.notifications, []);
    return list.filter((n) => !n.read).length;
  },

  async markAllRead() {
    await mockDelay(80);
    const list = storage.get(STORAGE_KEYS.notifications, []);
    const updated = list.map((n) => ({ ...n, read: true }));
    storage.set(STORAGE_KEYS.notifications, updated);
    return updated;
  },

  async markRead(id) {
    const list = storage.get(STORAGE_KEYS.notifications, []);
    const updated = list.map((n) => (n.id === id ? { ...n, read: true } : n));
    storage.set(STORAGE_KEYS.notifications, updated);
    return updated;
  },
};
